// Create our Vue router:
import { createRouter, createWebHistory } from 'vue-router';
import { isEmpty } from 'lodash';

import { readFiltersFromURL, returnOnlyUrlFiltersFromUrl } from '../lib/filters';
import OrderConfirmation from '../views/OrderConfirmation.vue';
import ComparisonOverview from '../views/ComparisonOverview.vue';
import ProductClickOut from '../views/ProductClickOut.vue';
import FormView from '../views/FormView.vue';
import { useOrderStore } from '../stores/orderStore.js';
import WizardViewLoader from '../views/WizardViewLoader.vue';
import { logAnalyticsEvent } from '../../../../assets/js/helpers/bananas';

const energyComparerRouter = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/energie/start-vergelijken',
            component: WizardViewLoader,
            name: 'wizard',
            props: (route) => ({
                urlStep: route.query.step,
                urlPostcode: route.query.postcode,
                urlNumber: route.query.nr,
                urlNumberExtension: route.query.extension,
                urlCurrentProvider: route.query.currentProvider,
                urlFilters: returnOnlyUrlFiltersFromUrl(route.query),
            }),
        },
        {
            path: '/energie/vergelijken',
            component: ComparisonOverview,
            name: 'compare',
            props: (route) => ({
                urlPostcode: route.query.postcode,
                urlNumber: route.query.nr,
                urlNumberExtension: route.query.extension,
                urlFilters: readFiltersFromURL(route.query),
            }),
        },
        {
            path: '/energie/aanvragen',
            component: FormView,
            name: 'form',
            beforeEnter: (to, from, next) => {
                const orderStore = useOrderStore();
                if (from.name === 'compare') {
                    orderStore.orderFlowSignup = false;
                }
                if (orderStore.product !== null) {
                    next();
                } else {
                    logAnalyticsEvent('compare-energy.order-signup-error-no-product');
                    next({ name: 'compare' });
                }
            },
        },
        {
            path: '/energie/vergelijken/:provider/:productID',
            component: ProductClickOut,
            name: 'productLink',
            props: (route) => ({
                productID: route.params.productID,
                urlPostcode: route.query.postcode,
                urlNumber: route.query.nr,
                urlFilters: readFiltersFromURL(route.query),
            }),
        },
        {
            path: '/energie/bedankt',
            component: OrderConfirmation,
            name: 'confirmation',
            beforeEnter: (to, from, next) => {
                const orderStore = useOrderStore();

                if (orderStore.submittedOrder !== null) {
                    next();
                } else {
                    next({ name: 'compare' });
                }
            },
        },
    ],
});

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 * https://vuejscode.com/vue-router-—-uncaught-in-promise-error-redirected-from-login-to-via-a-navigation-guard
 */
const originalPush = energyComparerRouter.push;
energyComparerRouter.push = function push(location) {
    return originalPush.call(this, location)
        .catch(() => {
        });
};

// Send virtual pageview events when URL changes:
energyComparerRouter.afterEach((to, from) => {
    if (from.name !== null) {
        // We _assume_ that each view has a name
        // Name is null on initial load, so no pageview event triggered
        if (typeof window.bananas !== 'undefined') {
            if (to.name !== from.name) {
                window.bananas('pageview');
            }
        }
    }
});
energyComparerRouter.beforeEach((to, from, next) => {
    if (from.name !== null && from.name !== to.name) {
        document.querySelector('footer')
            .classList
            .remove('show');
    }

    // Catching this error is not possible on a navigation guard I guess!??!!??.
    // https://router.vuejs.org/guide/advanced/navigation-failures.html#detecting-navigation-failures
    if (isEmpty(to.query) && !isEmpty(from.query) && to.name !== 'wizard') {
        next({
            ...to,
            query: from.query,
        });
    } else {
        next();
    }
});

export default energyComparerRouter;
